import { Redirect, type RouteComponentProps, Router } from '@gatsbyjs/reach-router'
import React, { type FunctionComponent } from 'react'

import { useUser } from '../../hooks/useUser'
import Page404 from '../../pages/404'
import CollaborationsProvider from '../../providers/CollaborationsProvider'
import { routes } from '../../utils/routes'
import MyCollabs from '../my-collabs/MyCollabs'

const MyCollabRoutes: FunctionComponent<React.PropsWithChildren<RouteComponentProps>> = () => {
  const { redirectToLoginIfNotLoggedIn } = useUser()

  if (redirectToLoginIfNotLoggedIn()) return null

  return (
    <CollaborationsProvider>
      <Router basepath="/">
        <Redirect noThrow replace from={routes.myCollabs.path} to={routes.myCollabs.overview.path} />
        <MyCollabs path={routes.myCollabs.overview.path} />
        <Page404 default />
      </Router>
    </CollaborationsProvider>
  )
}

export default MyCollabRoutes
